import React,{ useState }  from 'react';
import './index.scss';
import PropTypes from 'prop-types';
import PSIcon from "../../PSIcon";

const PopoverOptions = React.forwardRef(({className, onDelete, onShow}, ref) => {

    return (
      <div className={`container-popoverOptions ${className}`}>
        <div className="option" onClick={onShow}>
          <PSIcon type="download" className="margin-icon"/>
          <span>Descargar</span>
        </div>
        <div className="option" onClick={onShow}>
          <PSIcon type="copy" className="margin-icon"/>
          <span>Copiar</span>
        </div>
        <div className="option option-delete" onClick={()=>{onShow();onDelete()}}>
          <PSIcon type="trash" className="margin-icon"/>
          <span>Eliminar archivo</span>
        </div>
      </div>
    );
  }

);

PopoverOptions.displayName = 'PopoverOptions';

PopoverOptions.defaultProps = {
  className: '',
	onDelete: () => {},
	onShow: () => {}
};

PopoverOptions.propTypes = {
  className: PropTypes.string,
	onDelete: PropTypes.func,
	onShow: PropTypes.func,
};

export default PopoverOptions;